import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
// Services
import { SystemApiService } from '@cv-invision/core';
// Model
import { OrganizationModel } from '../model/organization.model';
import { map } from 'rxjs';

@Injectable()
export class OrganizationsService {
    public provider = 'classvaluation';
    constructor(
        private systemApiService: SystemApiService,
        private httpClient: HttpClient,
    ) {}
        /**
     * Gets the organizations from the users api
     * @param {string} nameFilter - Filters the organizations by name.
     */
        public getOrganizations(nameFilter?: string) {
            let params: HttpParams = new HttpParams();
            if(nameFilter){
                params = params.set('Name', nameFilter);
            }

            return this.httpClient.get(`${this.systemApiService.api['identitySystemService']}${this.provider}/organizations`, {params}).pipe(
                map((response: any) => {
                    let organizations: OrganizationModel[] = [];
                    if(response.data){
                        organizations = response.data.map((organization) => {
                            const organizationObj: OrganizationModel = {
                                id: organization.id ?? '',
                                name: organization.name ?? '',
                            }
                            return organizationObj;
                        });
                    }
                    return organizations;
                })
        )}
}